import { Modal } from "react-bootstrap";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import withPermission from "../../../core/common/autorisations/withPermission";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};
const DiplomeModalApercu = ({ show, metaData, onClose }: Props) => {
  // Fonction pour télécharger le PDF
  // 🔽 Personnalisation du nom du fichier
  const handleDownload = () => {
    const url = metaData?.pdfBlobUrl;
    if (!url) return;

    // Créer un lien temporaire
    const a = document.createElement("a");
    a.href = url;

    // 🔽 Personnalisation du nom du fichier
    const nomEtudiant = metaData?.studentName || "Etudiant";
    const cycle = metaData?.cycleLabel || "Cycle";
    const annee = metaData?.academicYear || "Annee";

    a.download = `Certificat_${nomEtudiant}_${cycle}_${annee}.pdf`;
    a.click();
  };

  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Aperçu du Diplôme</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={metaData?.pdfBlobUrl}
            style={{ width: "100%", height: "100%" }}
            title="Aperçu PDF"
          />
        </Modal.Body>
        <Modal.Footer className="gap-2">
          <button
            className="btn btn-primary"
            onClick={handleDownload}
            disabled={!metaData?.pdfBlobUrl}
          >
            Télécharger
          </button>
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  DiplomeModalApercu,
  [buildPermission(Resource.DIPLOME, Action.CREATE)],
  "masquer",
);
